import { createApp } from 'vue';
import AppComponent from './App.vue';
import router from './router';
import { createApollo } from '@acs/components-library/src/apollo.js';
import { injectFavicons } from '@acs/components-library/src/appLabel/favicon.js';
import { setCustomHeadersGenerator } from '@acs/components-library/src/fetch.js';
import {
  version as packageVersion,
  name as packageName,
} from '../package.json';
import { getLocale, i18n } from './i18n.js';
import { initSentry, captureSentryException } from '@acs/components-library/src/sentry.js';
import { createPinia } from 'pinia';

const { VITE_APP_TITLE, MODE } = import.meta.env;
document.title = VITE_APP_TITLE as string;

injectFavicons();

const pinia = createPinia();

async function main(): Promise<void> {
  const app = createApp(AppComponent).use(router);

  initSentry(app, router);

  const customHeaders: Record<string, string> = {
    'Accept-Language': getLocale(),
    'X-App-Name': packageName,
    'X-App-Version': packageVersion,
    'X-Mode': MODE,
  };

  setCustomHeadersGenerator(() => customHeaders);
  const { provider: apolloProvider } = await createApollo(customHeaders);

  app.use(apolloProvider);
  app.use(i18n);
  app.use(pinia);

  await router.isReady();

  app.mount('#app');
}

main().catch(captureSentryException);
